export const tooltips = {
	// General Info tooltips
	sku:
		"SKU (Unidad de Mantenimiento de Stock) es un código único para identificar el producto. Si no lo completas, generaremos uno automáticamente.",
	preparationTime: "Ingresa el tiempo que tarda la cocina en preparar este producto",
	hasAlcohol: "Al activarlo, aparecerá en el menú para clientes que contiene alcohol",

	// Stock tooltips
	isStockable:
		"Los productos almacenables son aquellos que se guardan en inventario hasta que se venden o usan.",
	conversionRule:
		"Define cómo las unidades de venta se convierten a unidades de stock. Ej: 1 botella = 1 litro",

	// Fiscal Data tooltips
	ncm: "Nomenclatura Común del Mercosur",
	cest: "Código Especificador de Sustitución Tributaria",
	fiscalProfile:
		"Conjunto de datos que describe la situación fiscal de una persona o empresa.",
	fiscalGroup: "Grupo fiscal es un código que clasifica productos según su tributación.",

	// Pricing tooltips
	variablePrice:
		"Precio variable: el precio del producto se definirá en el punto de venta",
};
